<template>
  <IndexBlok :id="2"></IndexBlok>
</template>

<script>

    import IndexBlok from "../../components/Doc/IndexBlok";

    export default {
        components: {IndexBlok},

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Vezne/index.vue